import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Select,
  Snackbar,
  Typography,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../../components/Header";
import { authFetch } from "../../../Utils/apiClient";

function EditSubcscription() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("Active");
  const [subscriber, setSubscriber] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, severity: "success", message: "" });

  useEffect(() => {
    const load = async () => {
      try {
        const res = await authFetch(`/package/getsubscribe/${id}`);
        const json = await res.json();
        if (json.status && json.result) {
          setSubscriber(json.result);
          setStatus(json.result.active ? "Active" : "Inactive");
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const handleSubmit = async () => {
    try {
      const res = await authFetch(`/package/updateStatus/${id}`, {
        method: "PUT",
        body: JSON.stringify({ status }),
      });
      const json = await res.json();
      if (json.status) {
        setSnackbar({ open: true, severity: "success", message: "Subscription updated" });
        setTimeout(() => navigate("/subscribedusers"), 1500);
      } else {
        setSnackbar({ open: true, severity: "error", message: json.message || "Update failed" });
      }
    } catch (err) {
      setSnackbar({ open: true, severity: "error", message: "Update failed" });
    }
  };

  if (loading) {
    return (
      <Box m="20px" display="flex" justifyContent="center" height="50vh" alignItems="center">
        <CircularProgress />
      </Box>
    );
  }

  if (!subscriber) {
    return (
      <Box m="20px">
        <Header title={`Edit Subscribed User Id: ${id}`} subtitle="" />
        <Typography mt={3}>Subscriber not found.</Typography>
      </Box>
    );
  }

  const pkg = subscriber.Package || {};
  const user = subscriber.User || {};

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title={`Edit Subscribed User Id: ${id}`} subtitle="" />
      <Box ml="40px">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">User: {user.profileName || "N/A"}</Typography>
            <Typography>Email: {user.email || "N/A"}</Typography>
            <Typography>Package: {pkg.package_name || "N/A"}</Typography>
            <Typography>Amount: ${pkg.amount ?? "N/A"}</Typography>
            <Typography>
              End Date:{" "}
              {subscriber.endDate
                ? new Date(subscriber.endDate).toLocaleDateString("en-US")
                : "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography fontWeight="bold" mb={1}>
              Status
            </Typography>
            <Select value={status} onChange={(e) => setStatus(e.target.value)} sx={{ minWidth: 140 }}>
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" onClick={handleSubmit} sx={{ backgroundColor: "#6870fa" }}>
              Update
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
      >
        <MuiAlert severity={snackbar.severity}>{snackbar.message}</MuiAlert>
      </Snackbar>
    </Box>
  );
}

export default EditSubcscription;
